<app-layout>
    <div class="reports-shell">
        <mat-toolbar class="page-header" role="heading">
            <div class="title-group">
                <span class="eyebrow">Insights</span>
                <h1>Reports</h1>
            </div>
        </mat-toolbar>

        <div class="reports-layout">
            <aside class="admin-panel" *appHasFeature="features.REPORTS_ADMINISTRATOR">
                <div class="panel-header">
                    <span class="panel-label">Administration</span>
                    <h2>Report management</h2>
                </div>

                <div class="action-list">
                    <button
                        matRipple
                        type="button"
                        setColor
                        [setColorRules]="[
                            {
                                color: 'primaryColour',
                                style: 'border-color'
                            },
                            {
                                color: 'primaryColour',
                                style: 'background-color',
                                events: ['hover']
                            }
                        ]"
                        class="admin-action"
                        *ngFor="let action of adminActions"
                        (click)="action.action()"
                    >
                        <span setColor="primaryColour" class="action-icon material-icons-outlined">{{ action.icon }}</span>
                        <span class="action-copy">
                            <strong>{{ action.title }}</strong>
                            <small>{{ action.description }}</small>
                        </span>
                    </button>
                </div>
            </aside>

            <section class="browse-panel">
                <div class="panel-header">
                    <div>
                        <span class="panel-label">Overview</span>
                        <h2>{{ browseSectionTitle }}</h2>
                    </div>

                    <div class="search-bar">
                        <mat-form-field class="search-input" appearance="outline">
                            <mat-label>{{ 'Search' | translate: {Default: 'Search'} }}</mat-label>
                            <input matInput [(ngModel)]="searchText" autocomplete="off">
                            <mat-icon class="material-icons-outlined" matPrefix aria-hidden="true">search</mat-icon>
                        </mat-form-field>
                    </div>
                </div>

                <ng-container *ngIf="filterReports(reports$ | async) as filteredReports">
                    <div class="content">
                        <ng-container *ngFor="let report of filteredReports">
                            <ng-container *appHasModuleAccess="report?.module">
                                <mat-card
                                    setColor
                                    [setColorRules]="[
                                        {
                                            color: 'primaryColour',
                                            style: 'border-color'
                                        },
                                        {
                                            color: 'primaryColour',
                                            style: 'background-color',
                                            events: ['hover']
                                        }
                                    ]"
                                    [routerLink]="report.href"
                                    class="report-card mat-elevation-z0"
                                    *appHasFeature="report.featureCode"
                                >
                                    <div class="icon-badge">
                                        <span setColor="primaryColour" class="material-icons-outlined">
                                            {{report.icon}}
                                        </span>
                                    </div>

                                    <div class="text">
                                        <mat-card-title class="header">
                                            {{report.name}}
                                        </mat-card-title>
                                        <mat-card-content *ngIf="report.detail">
                                            {{report.detail}}
                                        </mat-card-content>
                                    </div>

                                    <!-- <ng-container *appHasFeature="features.REPORTS_ADMINISTRATOR">
                                        <div *ngIf="showMenu(report.id)" class="menu-actions">
                                            <button
                                                mat-icon-button
                                                [matMenuTriggerFor]="reportMenu"
                                                aria-label="Report actions"
                                                (click)="$event.stopPropagation()"
                                            >
                                                <mat-icon class="material-icons-outlined" aria-hidden="true">more_vert</mat-icon>
                                            </button>

                                            <mat-menu #reportMenu="matMenu">
                                                <button mat-menu-item (click)="$event.stopPropagation(); goToEditReport(report.id)">
                                                    <mat-icon class="material-icons-outlined" style="margin-right: 8px !important;" aria-hidden="true">edit</mat-icon>
                                                    <span>{{ 'Edit' | translate: {Default: "Edit"} }}</span>
                                                </button>
                                            </mat-menu>
                                        </div>
                                    </ng-container> -->
                                </mat-card>
                            </ng-container>
                        </ng-container>

                        <div class="no-results" *ngIf="filteredReports.length === 0">
                            {{ 'NoReportsResultsFound' | translate: {Default: 'No matching reports found'} }}
                        </div>
                    </div>
                </ng-container>
            </section>
        </div>
    </div>
</app-layout>

